import React from "react";

const ServicesPage = () => (
  <div className="page-content">
    <p>Professional and freelancing work that I sometimes engage in.</p>
    <ul>
      <li>Backend/Fullstack Applications(Ruby on Rails, Node,...)</li>
      <li>Front-end Applications (React, Angular...)</li>
      <li>UI/UX</li>
      <li>Web Design (CMS preferred)</li>
      <li>Graphic/Logo Design</li>
      <li>
        Drafting (Piping and Instrumentation Diagrams/Process Flow
        Diagrams/Isometrics)
      </li>
      <li>Small scale 3d Modelling (.obj / 3ds Max)</li>
    </ul>
  </div>
);

export default ServicesPage;
